import React from 'react';

import * as shapes from '../../shapes';

const ProductNavigation = ({
  hasFilters,
  categoryName,
  brandName,
  resetFilters,
}) => (
  <div className="layout layout--small layout--auto layout--middle">
    <div className="layout__item" display-if={hasFilters}>
      <button
        type="button"
        className="c-btn c-btn--outline c-btn--outline-grey u-mr"
        onClick={resetFilters}
      >
        Back
      </button>
    </div>
    <div className="layout__item" display-if={categoryName}>
      <h4>Category: {categoryName}</h4>
    </div>
    <div className="layout__item" display-if={brandName}>
      <h4>Brand: {brandName}</h4>
    </div>
  </div>
);
ProductNavigation.propTypes = {
  hasFilters: shapes.flag.isRequired,
  categoryName: shapes.string,
  brandName: shapes.string,
  resetFilters: shapes.handler.isRequired,
};
ProductNavigation.defaultProps = {
  categoryName: '',
  brandName: '',
};

export default ProductNavigation;
